import React, { createContext, useState, useEffect, useContext } from 'react';
import CommonType from './types/CommonType';
import { NOTIFICATION_TYPES, NotificationContext } from './NotificationContext';
import { LoadingContext } from './LoadingContext';
import LanguageType from './types/LangugaeType';
import { LocalStorageHelper } from '../utils/LocalStorageHelper';
import logger from '../utils/logger';

const LOCAL_STORAGE_LANGUAGES = 'LOCAL_STORAGE_LANGUAGES';

export const LanguageContext = createContext({
  languages: [] as LanguageType[],
});

const LanguageProvider: React.FC<CommonType> = (props) => {
  const [languages, setLanguagesData] = useState<LanguageType[]>([]);
  const { setType, setMessage } = useContext(NotificationContext);
  const { setLoading } = useContext(LoadingContext);

  useEffect(() => {
    logger.context.debug('Initializing language data');
    setLoading(true);
    const localLanguages = LocalStorageHelper.getLocalResponseDataWithExpiration<LanguageType[]>(LOCAL_STORAGE_LANGUAGES);

    if (localLanguages !== null) {
      logger.context.debug('Using cached languages:', localLanguages.data?.length, 'items');
      setLanguagesData(localLanguages.data);
      setLoading(false);
    } else {
      logger.context.debug('Loading languages from public API');
      // Use public services as languages should be publicly accessible
      import('../service/publicServices').then(({ default: publicServices }) => {
        publicServices.getLanguages()
        .then((response) => {
          logger.context.debug('Languages loaded successfully:', response.data?.length, 'items');
          setLanguagesData(response.data);
          LocalStorageHelper.setLocalResponseDataWithExpiration(LOCAL_STORAGE_LANGUAGES, response);
        })
        .catch((error) => {
          logger.context.error('Error loading languages:', error);
          setType(NOTIFICATION_TYPES.FAILED);
          setMessage(error.message);
        })
        .finally(() => {
          setLoading(false);
        });
      }).catch((importError) => {
        // Handle dynamic import error
        logger.context.error('Failed to load language services:', importError);
        setType(NOTIFICATION_TYPES.FAILED);
        setMessage('Failed to load languages');
        setLoading(false);
      });
    }
  }, []);

  return (
    <LanguageContext.Provider value={{ languages }}>
      {props.children}
    </LanguageContext.Provider>
  );
};

export default LanguageProvider;
